@if (visible()) {
  <div class="cookie-banner" role="dialog" aria-labelledby="cookie-banner-title" aria-describedby="cookie-banner-description">
    <div class="cookie-banner__container">
      <div class="cookie-banner__content">
        <div class="cookie-banner__icon">
          <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        </div>

        <div class="cookie-banner__text">
          <h3 id="cookie-banner-title" class="cookie-banner__title">
            {{ 'cookie-banner-title' | translate }}
          </h3>
          <p id="cookie-banner-description" class="cookie-banner__description">
            {{ 'cookie-banner-description' | translate }}
            <a [href]="termsAndConditionsLink" target="_blank" rel="noopener noreferrer" class="cookie-banner__link">
              {{ 'cookie-banner-learn-more' | translate }}
            </a>
          </p>
        </div>
      </div>

      <div class="cookie-banner__actions">
        <button
          nz-button
          nzType="default"
          (click)="onDeclineAll()"
          [nzLoading]="loading()"
          [disabled]="loading()"
          class="cookie-banner__button cookie-banner__button--decline">
          {{ 'cookie-banner-decline-all' | translate }}
        </button>

        <button
          nz-button
          nzType="default"
          (click)="onCustomize()"
          [disabled]="loading()"
          class="cookie-banner__button cookie-banner__button--customize">
          {{ 'cookie-banner-customize' | translate }}
        </button>

        <button
          nz-button
          nzType="primary"
          (click)="onAcceptAll()"
          [nzLoading]="loading()"
          [disabled]="loading()"
          class="cookie-banner__button cookie-banner__button--accept">
          {{ 'cookie-banner-accept-all' | translate }}
        </button>
      </div>
    </div>

    <!-- Cookie Settings Modal -->
    @if (showSettings()) {
      <cookie-settings (close)="onSettingsClosed()" />
    }
  </div>
}
